import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function createOrder(payload) {
  const response = await axiosClient.post("/Orders", payload);
  return response.data;
}

export async function getOrders() {
  const response = await axiosClient.get("/Orders");
  return response.data;
}

export async function getOrderById(orderId) {
  const response = await axiosClient.get(`/Orders/${orderId}`);
  return response.data;
}

export async function getBusinessOrders(params) {
  const response = await axiosClient.get(`/Orders/business${toQueryString(params)}`);
  return response.data;
}

export async function getBusinessOrderById(id) {
  const response = await axiosClient.get(`/Orders/business/${id}`);
  return response.data;
}

export async function updateBusinessOrderStatus(id, status, note) {
  const response = await axiosClient.put(`/Orders/business/${id}/status`, { status, note });
  return response.data;
}

export async function removeBusinessOrderItem(orderId, itemId, note) {
  const response = await axiosClient.put(`/Orders/business/${orderId}/items/${itemId}/remove`, { note });
  return response.data;
}

export async function restoreBusinessOrderItem(orderId, itemId) {
  const response = await axiosClient.put(`/Orders/business/${orderId}/items/${itemId}/restore`);
  return response.data;
}
